import { createFileRoute } from '@tanstack/react-router';
import { CampaignDetail } from '@/pages';

export const Route = createFileRoute('/_authenticated/campaign/$id/')({
  component: CampaignDetail,
});
